

import React, { useEffect, useRef, useState } from "react"; 
import {VisDiv, MonthYearWheel} from "../components";
import useMediaQuery from "../hooks/useMediaQuery";
import {usePreventScroll} from 'react-aria'
import { screenPosition as screenPos} from '../lib/utils';
import { useStateContext } from "../context/StateContext";


const Icon = () => {
    return (
      <svg height="20" width="20" viewBox="0 0 20 20">
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
      </svg>
    );
  };
  
  const CloseIcon = () => {
    return (
      <svg height="20" width="20" viewBox="0 0 20 20">
        <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
      </svg>
    );
  };

const FieldDropdown = ({
  placeHolder,
  options,
  isMulti,
  isSearchable,
  onChange,
  initialValue,
  descending,
  isError,
  errorMessage,
  sorted,
  hideDeselect
}) => {
    const {setDropdownScreenPosition, dropdownScreenPosition} = useStateContext()
    const [showMenu, setShowMenu] = useState(false);
    const [selectedValue, setSelectedValue] = useState(isMulti ? [] : undefined);
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();
    const inputRef = useRef();
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
   
    useEffect(() => {
      setSearchValue("");
      //console.log(screenPos())
      if (showMenu && searchRef?.current) {
        searchRef?.current?.focus();
      }
   
    }, [showMenu]);
    

    usePreventScroll({isDisabled: !showMenu})

    useEffect(() => {
      const handler = (e) => {
        if (inputRef?.current && !inputRef?.current?.contains(e?.target)) {
          //console.log("handler")
          setShowMenu(false);
        }
      };
  
      window?.addEventListener("click", handler);
      return () => {
        window?.removeEventListener("click", handler);
      };
    });

    useEffect(()=>{
      if (initialValue){
        //console.log("DEFAULT VALUE IN DROPDOWN:",initialValue)
        setSelectedValue(initialValue)
        //onChange(initialValue);
      };
    },[initialValue])

    const handleInputClick = (e) => {
      //e.stopPropagation();
      //("Handle Input click")
      if(!showMenu){
        //console.log("SCREEN POSITION",screenPos())
        setDropdownScreenPosition(screenPos())
      }
      if(showMenu){
        window?.scrollTo(0, dropdownScreenPosition);
      }
      setShowMenu(!showMenu);
    };

    const sortOptions = (a,b) =>{
      //sorting
      if(descending) return (b?.label > a?.label) ? 1 : ((a?.label > b?.label) ? -1 : 0)
      return (a?.label > b?.label) ? 1 : ((b?.label > a?.label) ? -1 : 0)
  }
  const key = (option, index) => {
    if(option?._id) return option?._id
    if(option?._key) return option?._key
    return index
  }
  
    const getDisplay = () => {
      if (!selectedValue || selectedValue?.length === 0 || (!selectedValue?.label && !isMulti)) {
        return placeHolder;
      }
      if (isMulti) {
        return (
          <div className="dropdown-tags">
            {selectedValue
            //?.sort((a,b) => sorted && sortOptions(a,b))
            ?.map?.((option, index) => {

              return(
              <div key={key(option, index)} className="dropdown-tag-item">
                {option?.label}
                <span
                  onClick={(e) => onTagRemove(e, option)}
                  className="dropdown-tag-close"
                >
                  <CloseIcon />
                </span>
              </div>
            )})}
          </div>
        );
      }
      return selectedValue?.label;
    };
  
    const removeOption = (option) => {
      return selectedValue.filter?.((o) => o?.value !== option?.value);
    };
  
    const onTagRemove = (e, option) => {
      e?.stopPropagation();
      const newValue = removeOption(option);
      setSelectedValue(newValue);
      onChange(newValue);
    };

    const deselect = () => {
      //e?.stopPropagation();
      setSelectedValue(undefined);
      onChange(undefined);
      handleInputClick()
    };
  
    const onItemClick = (option) => {
      let newValue;
      if (isMulti) {
        
        //console.log("clicked multi")

        if (selectedValue?.findIndex((o) => o?.value === option?.value) >= 0) {
          newValue = removeOption(option);
        } else {
          newValue = [...selectedValue, option];
        }
      } else {
        newValue = option;
        handleInputClick()

      }
      setSelectedValue(newValue);
      onChange(newValue);
    };
  
    const isSelected = (option) => {
      if (isMulti) {
        return !Array.isArray(selectedValue) ? [] : selectedValue?.filter?.((o) => o?.value === option?.value)?.length > 0;
      }
  
      if (!selectedValue) {
        return false;
      }
  
      return selectedValue?.value === option?.value;
    };
  
    const onSearch = (e) => {
      setSearchValue(e?.target?.value);
    };

    const onSearchClick = (e) => {
      e?.stopPropagation()
    };
  
    const getOptions = () => {
      if (!searchValue) {
        return options;
      }
  
      return !Array.isArray(options) ? [] : options?.filter?.(
        (option) =>
          option?.label?.toLowerCase()?.indexOf(searchValue?.toLowerCase()) >= 0
      );
    };
    const borderError = isError && "red"
  
    return (
      <>
      <div className="dropdown-container" style={{borderColor: borderError, fontSize:"16px"}}>
        <div ref={inputRef} onClick={handleInputClick} className="dropdown-input">
          <div className="dropdown-selected-value">{getDisplay()}</div>
            <div className="dropdown-tools">
              <div className="dropdown-tool">
                <Icon />
              </div>
          </div>
        </div>
        
{/*         {showMenu && (
            <VisDiv rules={[false]} className="dropdown-menu">
              {isSearchable && (
                <div className="search-box">
                  <input onClick={(e)=>onSearchClick(e)} onChange={onSearch} value={searchValue} ref={searchRef} />
                </div>
              )}
              {!isMulti && (
                <div onClick={()=>{deselect()}} className={`dropdown-item ${isSelected(false) && "selected"}`} style={{height:"25px"}}> </div>
              )}
              
              {getOptions()
              ?.sort((a,b)=>sorted && sortOptions(a,b))
              ?.map?.((option) => (
                <div
                  onClick={(e) => {
                    e.stopPropagation(); 
                    onItemClick(option)
                  }}
                  key={option?._id ? option._id : option._key}
                  className={`dropdown-item ${isSelected(option) && "selected"}`}
                >
                  {option.label}
                </div>
              ))}
            </VisDiv>

    
        )} */}
       
      </div>
      
        <VisDiv  onClick={(e)=>{e?.stopPropagation(); handleInputClick()}} className="lowbar-wrapper"  rules={[showMenu]}>
            <VisDiv  onClick={(e)=>{e?.stopPropagation()}} rules={[true]} className="lowbar-container" style={{backgroundColor:"white", height:"40%"}}>
            {isSearchable && (
                  <div className="search-box" >
                    <input onClick={(e)=>onSearchClick(e)} autoFocus={true} onChange={onSearch} value={searchValue} ref={searchRef} />
                  </div>
                )}
              <VisDiv className="dropdown-menu" style={{height:"85%", paddingBottom:"130px"}} rules={[true]} >
  
                {(!isMulti && !hideDeselect) && (
                  <div onClick={()=>{deselect()}} className={`dropdown-item ${isSelected(false) && "selected"}`} style={{height:"25px"}}> </div>
                )}
                
                {getOptions()
                ?.sort((a,b)=>sorted && sortOptions(a,b))
                ?.map?.((option, index) => {
                  return(
                  <div
                    onClick={(e) => {
                      e?.stopPropagation(); 
                      onItemClick(option)
                    }}
                    key={key(option, index)}
                    className={`dropdown-item ${isSelected(option) && "selected"}`}
                  >
                    {option?.label}
                  </div>
                )})}
              </VisDiv>
            </VisDiv>
        </VisDiv>
        {isError && <p style={{color:"red"}}>{errorMessage}</p>}
      </>
    );
  };

  export default FieldDropdown;
  